import {
  BasicInput,
  ButtonsAddCancel,
  Col,
  FormikAutocomplete,
  FormikSelect,
  PartialPick,
  Row
} from '@elotech/components';
import { EntidadeService } from 'common/service';
import { Entidade } from 'common/type';
import {
  SituacaoFuncionario,
  SituacaoFuncionarioSelectValues
} from 'common/type/SituacaoFuncionario';
import { Formik } from 'formik';
import React from 'react';

import { UsuarioFuncionario } from '../../../type/UsuarioFuncionario';
import ValidationSchemaUsuarioFuncionario from '../ValidationSchemaUsuarioFuncionario';

type Props = {
  initialValue?: UsuarioFuncionario;
  onSubmit: (value: UsuarioFuncionario) => void;
  onCancel: () => void;
};

type UsuarioFuncionarioFormValues = PartialPick<UsuarioFuncionario, 'entidade'>;

const initialValue: UsuarioFuncionarioFormValues = {
  id: '',
  matricula: '',
  cargo: '',
  lotacao: '',
  situacao: SituacaoFuncionario.ATIVO,
  entidade: undefined,
  usuarioId: '',
  moduloCadastrado: ''
};

const UsuarioFuncionarioForm: React.FC<Props> = props => {
  const handleSubmit = (values: UsuarioFuncionarioFormValues) => {
    props.onSubmit(values as UsuarioFuncionario);
  };

  return (
    <Formik<UsuarioFuncionarioFormValues>
      initialValues={
        (props.initialValue as UsuarioFuncionarioFormValues) || initialValue
      }
      onSubmit={handleSubmit}
      validationSchema={ValidationSchemaUsuarioFuncionario}
    >
      {formProps => (
        <>
          <Row>
            <FormikAutocomplete<Entidade>
              name={'entidade'}
              label={'Entidade'}
              placeholder="Digite o nome da entidade"
              getOptionValue={(value: Entidade) => value.id}
              getOptionLabel={(value: Entidade) => value.nome}
              onSearch={(search: string) =>
                EntidadeService.findAllPainel(search).then(response => ({
                  ...response,
                  data: response.data
                }))
              }
              size={3}
            />
            <BasicInput name="matricula" label="Matrícula" size={2} />
            <BasicInput name="cargo" label="Cargo" size={3} />
            <BasicInput name="lotacao" label="Lotação" size={3} />
          </Row>
          <Row>
            <FormikSelect
              name="situacao"
              label="Situação"
              options={SituacaoFuncionarioSelectValues}
              size={2}
              getOptionLabel={option => option.label}
              getOptionValue={option => option.value}
            />
          </Row>
          <Row className="mb-xs">
            <Col md={4} className="form-group">
              <ButtonsAddCancel
                onAdd={formProps.submitForm}
                onCancel={props.onCancel}
              />
            </Col>
          </Row>
        </>
      )}
    </Formik>
  );
};

export default UsuarioFuncionarioForm;
